import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Subscription } from 'rxjs';

import { CategoryMenu } from '@core/models/enum/category-menu.enum';
import { IMenu } from '@core/models/interfaces/menu.interface';
import { CurrentProduct } from '@core/models/types/current-product.type';

import { ImageUrlService } from '@services/assets-S3/image-url.service';
import { AuthStateService } from '@services/auth/auth-state.service';
import { AuthService } from '@services/auth/auth.service';
import { ProductStateService } from '@services/product/product-state.service';
import { LocalStorageService } from '@services/storage/local-storage.service';
import { MenuDesktopComponent } from './menu-desktop/menu-desktop.component';
import { MenuMobileComponent } from './menu-mobile/menu-mobile.component';

export const EMPTY_CART = 0;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    MenuDesktopComponent,
    MenuMobileComponent,
    RouterModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnDestroy {
  @ViewChild('tooltipCartTemplate', { static: false })
  tooltipCartTemplate!: TemplateRef<unknown>;

  showCartTooltip!: TemplateRef<unknown> | undefined;

  principalMenu!: IMenu[];
  userMenu!: IMenu[];
  loginMenu!: IMenu[];

  userFirstName!: string | null;
  evento!: CurrentProduct;
  isLoggedIn!: boolean;
  isLoggedInSubscription!: Subscription;
  productSubscription!: Subscription;

  logoUrl!: string;

  @Input() set menu(values: IMenu[]) {
    if (values) {
      this.filterMenu(values);
    }
  }

  constructor(
    private productStateService: ProductStateService,
    private authService: AuthService,
    private authStateService: AuthStateService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private imageUrlService: ImageUrlService
  ) {
    this.getLogoUrl();
    this.checkIfUserIsLoggedIn();
    this.getCurrentProduct();
  }

  getCurrentProduct(): void {
    this.productSubscription =
      this.productStateService.currentProduct.subscribe(
        (value: CurrentProduct) => {
          if (this.productStateService.productIsValid()) {
            this.evento = value;
            this.showCartTooltip = !this.emptyCart
              ? this.tooltipCartTemplate
              : undefined;
          }
        }
      );
  }

  checkIfUserIsLoggedIn(): void {
    this.isLoggedInSubscription = this.authStateService.isLoggedIn.subscribe(
      (value: boolean) => {
        this.isLoggedIn = value;
        if (value) {
          this.getUserFirstName();
        }
      }
    );
  }

  getUserFirstName(): void {
    const user = this.localStorageService.get('user');
    if (user) {
      this.userFirstName = JSON.parse(user).name.split(' ')[0];
    }
  }

  getLogoUrl() {
    this.logoUrl = this.imageUrlService.getImageUrl(
      'conteudo/img/logo/logo-tele-premios.webp'
    );
  }

  get totalValue(): number {
    return Number(this.evento?.value) * (this.evento?.quantity || 0);
  }

  get emptyCart(): boolean {
    return this.evento?.quantity === EMPTY_CART;
  }

  logout(): void {
    this.authService.logout().subscribe(
      () => {
        this.isLoggedIn = false;
        this.router.navigateByUrl(`/login.html`);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  filterMenu(menu: IMenu[]): void {
    this.principalMenu = menu.filter(
      item => item.category === CategoryMenu.PRINCIPAL
    );

    this.userMenu = menu.filter(
      item => item.category === CategoryMenu.USER_MENU
    );

    this.loginMenu = menu.filter(
      item => item.category === CategoryMenu.LOGIN_MENU
    );
  }

  ngOnDestroy(): void {
    this.isLoggedInSubscription.unsubscribe();
    this.productSubscription.unsubscribe();
  }
}
